import { animate, useInView, useMotionValue, useTransform } from "motion/react";
import { useEffect, useRef } from "react";
import { BuildingLineArt } from "./BuildingLineArt";
import { IntegratedHeading, IntegratedParagraph } from "./IntegratedCopy";

export function IntegratedSection() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const draw = useMotionValue(0);
  const controlsOpacity = useTransform(draw, [0.9, 1], [0, 1]);

  useEffect(() => {
    if (!inView) {
      return;
    }
    const animation = animate(draw, 1, { duration: 2.4, ease: "easeInOut" });
    return () => animation.stop();
  }, [inView, draw]);

  return (
    <section className="mx-auto flex max-w-6xl flex-col gap-12 px-8 py-20 md:px-6">
      <IntegratedHeading />
      <hr className="-mx-8 border-primary md:hidden landscape:hidden" />
      <div
        ref={ref}
        className="-mx-8 overflow-hidden px-8 text-illustration md:mx-0 md:overflow-visible md:px-0 landscape:mx-0 landscape:overflow-visible landscape:px-0"
      >
        <BuildingLineArt
          draw={draw}
          controlsOpacity={controlsOpacity}
          className="w-[250%] max-w-none animate-pan md:w-full landscape:w-full"
        />
      </div>
      <div className="md:flex md:justify-end">
        <IntegratedParagraph />
      </div>
    </section>
  );
}
